import axios from 'axios';
import api from './api';

export default {
    fetch(employeeId, startDate, endDate) {
        return axios.post('/dashboard/fetch/', {
            forEmployeeId: employeeId,
            startDate,
            endDate,
        });
    },
    fetchEfficiency(employeeId, startDate, endDate) {
        return axios.post('/dashboard/fetchEfficiency/', {
            forEmployeeId: employeeId,
            startDate,
            endDate,
        });
    },
    startVisit() {
        return axios.post('/dashboard/startVisit/');
    },
    endVisit(visitId) {
        return axios.post('/dashboard/endVisit/', { visitId });
    },
};
